"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getConfig = exports.init = exports.setup = void 0;
var shared_1 = require("@cian/peperrors/shared");
var shared_2 = require("../shared");
var configSettings = null;
var config = null;
function setup(params) {
    configSettings = params;
}
exports.setup = setup;
function init() {
    if (!config) {
        config = loadConfig();
    }
    return config;
}
exports.init = init;
function getConfig() {
    if (!config) {
        throw new shared_1.ConfigurationError({
            message: 'Config must be created before accessing it. Forgot to call init() before accessing config?',
            domain: 'config.getConfig',
        });
    }
    return config;
}
exports.getConfig = getConfig;
function loadConfig() {
    var container = window._cianConfig;
    if (!container) {
        throw new shared_1.NotFoundError({
            message: "_cianConfig - not found in window",
            domain: 'config.loadConfig',
        });
    }
    if (!configSettings) {
        throw new shared_1.ConfigurationError({
            message: 'Settings key was not set for config. Forgot to call setup() before config initialization?',
            domain: 'config.loadConfig',
        });
    }
    var settingsKey = configSettings.settingsKey;
    var settings = container[settingsKey];
    if (!settings) {
        throw new shared_1.NotFoundError({
            message: "Missing settings in _cianConfig." + settingsKey,
            domain: 'config.loadConfig',
        });
    }
    if (!Array.isArray(settings)) {
        throw new shared_1.ValidationError({
            message: "Expecting array of settings in _cianConfig." + settingsKey,
            domain: 'config.loadConfig',
            details: { payload: JSON.stringify(settings, null, 2) },
        });
    }
    settings.forEach(function (setting) {
        if (!shared_2.validate(setting)) {
            throw new shared_1.ValidationError({
                message: "Received unexpected entry in _cianConfig." + settingsKey,
                domain: 'config.loadConfig',
                details: { setting: JSON.stringify(setting, null, 2) },
            });
        }
    });
    var source = mkSource(settings);
    return new shared_2.Config({ source: source });
}
function mkSource(settings) {
    return {
        select: function (key) {
            if (!key) {
                return __spread(settings);
            }
            return settings.filter(function (setting) { return setting.key === key; });
        },
    };
}
//# sourceMappingURL=interface.js.map